import * as React from 'react';
import {
  Card
} from 'one-ui-card/src/card';
import Table from "antd/lib/table";
import Dropdown from "antd/lib/dropdown";
import Button from "antd/lib/button";
import Menu from "antd/lib/menu";
import {
  PendingReferralsModel
} from './model';

import {
  PendingReferalsCardProps
} from './props';

import {
  checkCardHasError,
  TabErrorMsg
} from 'one-card-notification';

/**
 * This function returns the Referral Tab
 * @param props is a component property
 * @returns JSX code for Referral Tab Card
 */
export const ReferralsTab = <M extends PendingReferralsModel>(
  props: PendingReferalsCardProps<M>
) => {
  const {
    model,
    handleMenuClick
  } = props;

  const {
    referalsdata
  } = model || {};

  let tabledata: any = [];
  let referalTabUI;
  
  if (referalsdata.referalsdata?.length > 0) {
    let referdata = referalsdata.referalsdata;
    referdata.forEach((infodata: any) => {
      tabledata.push(infodata);
    })
  }

  const menu = (e: any) => (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key={e.key + ",1"}>Show Referrals in Epic</Menu.Item>
    </Menu>
  );

  const columns = [
    {
      title: "Referral ID",
      dataIndex: "referalid",
      key: "referalid"
    },
    {
      title: "Referred By (Provider)",
      key: "referredby",
      dataIndex: "referredby"
    },
    {
      title: "Referred To (Provider)",
      key: "referredto",
      dataIndex: "referredto"
    },
    {
      title: "Referral Type",
      key: "referraltype",
      dataIndex: "referraltype"
    },
    {
      title: "Referral Status",
      key: "referralstatus",
      dataIndex: "referralstatus"
    },
    {
      title: "Action",
      key: "action",
      render: (text: any, record: any) => (
        <Dropdown overlay={menu(record)}>
          <Button type="link" size="small" className="ant-btn-link--dark">&hellip;</Button>
        </Dropdown>
      )
    }
  ];
  // To Check for the Error from the API
  if(checkCardHasError('PendingReferrals') && tabledata.length === 0){
    referalTabUI = 
    <>
        <TabErrorMsg />
    </>
  }
  else {
    referalTabUI = 
    <>
    <Table columns={columns} dataSource={tabledata} />
    </>
  }
  return (
    <Card
      title={""}
      body={referalTabUI}
    />
  )
}
